import React from 'react';
import LoadingSpin from '../LoadingSpin';

import styles from './styles.module.css';

export interface LoadingScreenProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  className,
  ...props
}) => {
  return (
    <div className={`${styles.loadingContainer} ${className}`} {...props}>
      <LoadingSpin />
    </div>
  );
};
